import { use_slice_generation, use_slice_ml_asset } from '@/hooks/store/use_slices';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { useMemo } from 'react';
import { G_UI_FIELD__token_list_add_embedding_item } from './G_UI_FIELD__token_list_add_embedding_item';
import { G_UI_FIELD__token_list_embedding__button_select_all } from './_buttons/G_UI_FIELD__token_list_embedding__button_select_all';

interface PROPS {
  is_positive: boolean;
  field: FIELD__list_token;
}

export function G_UI_FIELD__token_list_add_embedding({ is_positive, field }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { ml_assets_map } = use_slice_ml_asset(['ml_assets_map']);

  const ml_asset_list = useMemo(() => get_ml_asset_list(), [is_positive, generation_current, ml_assets_map]);

  function get_ml_asset_list() {
    if (generation_current.is_stub()) return [];
    if (field.meta.graph_id != generation_current._id) return [];

    let out = Array.from(ml_assets_map.values()).filter(item => item.type == ENUM__ml_asset_type.EMBEDDING);
    out = out.filter(item => item.family == field.meta.node_family);
    out = out.filter(item => item.config.get_embedding__is_sign_positive() == is_positive);

    return out;
  }

  return (
    <>
      <div className="flex flex-row items-center gap-1 px-2 h-5 text-xs px-1 bg-bar text-bar-foreground">
        <G_UI_FIELD__token_list_embedding__button_select_all {...{ field, ml_asset_list, is_positive }} />
        <span>{is_positive ? 'Positive Embeddings' : 'Negative Embeddings'}</span>
      </div>
      <div className="flex flex-col px-1 w-full bg-component">
        {ml_asset_list.map(ml_asset => (
          <G_UI_FIELD__token_list_add_embedding_item key={`embedding_${ml_asset.hash_sha256}`} {...{ is_positive, field, ml_asset }} />
        ))}
      </div>
    </>
  );
}
